<template>
  <v-row justify="center">
    <v-dialog v-model="shower" width="800px" scrollable persistent>  
      <v-card>
         <div class="ma-4 pa-0 text-center">
            <img
              src="@/assets/img/alert_check_admin2.png"
              width="80px"
              height="80px"
              alt="One Box"
            />
          </div>
          <div class="text-center">
            <h2 style="font-size: 20px;">{{ $t("balloon.you_do_not_have_permission") }}</h2>
          </div>
          <div class="text-center mt-2">
            <span style="font-size: 16px;">
                {{ $t("balloon.please_contact_the_admin") }}<br>
                <b>{{ $t("balloon.menu_manage_inbox_outbox_permission") }}</b>
                <!-- ไม่สามารถเข้าใช้งานได้ เนื่องจากไม่มีสิทธิ์ใช้งาน กรุณาติดต่อผู้ดูแลระบบ -->
            </span>
          </div>
        <v-card-text class="pa-6">
                    <div v-if="resolutionScreen >= 400">                    
                      <v-card>
                        <v-overlay v-if="loadprogress === true" :value="loadprogress" absolute :color="color.BG" dark>
                          <v-progress-circular indeterminate size="64" :color="color.theme"></v-progress-circular>
                          <!-- <span :style="colorProgress">&nbsp; loading</span> -->
                        </v-overlay>
                      <v-data-table
                        fixed-header
                        height="335px"
                        :headers="header"
                        :items="listadmin"
                        class="elevation-0"
                        :no-data-text="$t('tablefile.empty_resend')"
                        :page.sync="page"
                        :items-per-page="total_admin"
                        :hide-default-footer="true"
                        @page-count="pageCount = $event"
                      >
                        <template v-slot:[`header.name`]="{ header }">
                          <span :style="headerTable">{{$t(header.text)}}</span>
                        </template>
                        <template v-slot:[`header.email`]="{ header }">
                          <span :style="headerTable">{{$t(header.text)}}</span>
                        </template>
                        <template v-slot:[`header.mobile`]="{ header }">
                          <span :style="headerTable">{{$t(header.text)}}</span>
                        </template>

                        <template v-slot:item="props">
                          <tr class="pointer" style="cursor:pointer;">
                            <td v-if="$t('default') === 'th'" class="text-center" width="10%">
                              <v-icon :color="color.theme">mdi-account-star</v-icon>
                            </td>
                            <td v-if="$t('default') === 'th'" class="text-center" width="30%">
                              {{ props.item.first_name_th === null ? '-' : props.item.first_name_th === '' ? '-' : props.item.first_name_th}}
                              {{ props.item.last_name_th === null ? '' : props.item.last_name_th === '' ? '' : props.item.last_name_th}}
                            </td>
                            <td v-else class="text-center" width="30%">
                              {{ props.item.first_name_eng === null ? '-' : props.item.first_name_eng === '' ? '-' : props.item.first_name_eng}}
                              {{ props.item.last_name_eng === null ? '' : props.item.last_name_eng === '' ? '' : props.item.last_name_eng}}
                            </td>
                            <td class="text-center" width="30%">
                              {{ props.item.email === null ? '-' : props.item.email === '' ? '-' : props.item.email}}
                            </td>
                            <td class="text-center" width="30%">
                              {{ props.item.mobile === null ? '-' : props.item.mobile === '' ? '-' : props.item.mobile}}
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                      </v-card>
                    </div>
                    <div v-else>
                      <v-card :style="displayMobile">
                      <v-list dense two-line class="mb-0 pb-0 elevation-0" v-if="listadmin.length !== 0" :style="styleDisplayMobile">
                        <v-list-item v-for="item in listadmin" :key="item.title" style="cursor: pointer" :style="displayMobileForListItem">
                          <v-list-item-content>
                            <v-list-item-title v-if="$t('default') === 'th'" style="line-height:22px;" v-text="(item.first_name_th === null ? '-' : item.first_name_th === '' ? '-' : item.first_name_th) +' '+ (item.last_name_th === null ? '' : item.last_name_th === '' ? '' : item.last_name_th)"></v-list-item-title>
                            <v-list-item-title v-else style="line-height:22px;" v-text="(item.first_name_eng === null ? '-' : item.first_name_eng === '' ? '-' : item.first_name_eng) +' '+ (item.last_name_eng === null ? '' : item.last_name_eng === '' ? '' : item.last_name_eng)"></v-list-item-title>
                            <v-list-item-subtitle v-text="item.email === null ? '-' : item.email === '' ? '-' : item.email"></v-list-item-subtitle>
                            <v-list-item-subtitle v-text="item.mobile === null ? '-' : item.mobile === '' ? '-' : item.mobile"></v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action style="align-self: center;">
                            <v-btn
                              class="elevation-0"
                              fab
                              small
                            >
                              <v-icon :color="color.theme">mdi-account-star</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                      <v-list v-else class="mb-6 pb-6 elevation-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title class="text-center" v-text="$t('tablefile.empty')"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      </v-card>
                    </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions v-if="resolutionScreen >= 400">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="$emit('closedialog')">{{ $t("consent.close") }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else style="justify-content: center;">
        <v-btn
          height="40px"
          class="elevation-0"
          :style="btnAction"
          width="40%"
          :color="color.theme"
          dark
          @click="$emit('closedialog')"
          >{{ $t("consent.close") }}</v-btn
        >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import gbfGenerate from "@/globalFunctions/generateAuthorize";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import { required, maxLength, email } from "vuelidate/lib/validators";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
    props: ["show"],
    components:{
    },
     data() {
    return {
      loadprogress: false,
      listadmin:[],
      total_admin:[],
      size: 20,
      page: 1,
      listsize: [10, 20, 50, 100],
      header: [
        {
          text: "",
          align: "center",
          value: "type",
          width: "10%",
          sortable: false,
        },
        {
          text: "admin.fullname",
          align: "center",
          value: "name",
          width: "30%",
          sortable: false,
        },       
        {
          text: "admin.business_email",
          align: "center",
          value: "email",
          width: "30%",
          sortable: false,
        },
        {
          text: "admin.mobile",
          align: "center",
          value: "mobile",
          width: "30%",
          sortable: false,
        },
      ],
        }
     },
     computed: {
    ...mapState(["username", "authorize", "account_active", "color"]),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
      "dataStorageUsage",
      "dataStorageMax",
      "dataCheckPackage",
    ]),
    resolutionScreen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
      }
    },
    // pageCount: {
    //   get() {
    //     let l = this.total_admin.length;
    //     let s = this.size;
    //     return Math.ceil(l / s);
    //   },
    //   set(newName) {
    //     return newName;
    //   },
    // },
    // paginatedData() {
    //   const start = (this.page - 1) * this.size;
    //   const end = start + this.size;
    //   return this.total_admin.slice(start, start + this.size);
    // },
    headerTable() {
      return (
        "color:" + this.color.theme + ";" + "font-weight: 600; font-size:15px;"
      );
    },
    headerPage() {
      return (
        "color:" + this.color.theme + ";" + "font-size: 18px; font-weight: 600;"
      );
    },
    colorVapp() {
      return "background:" + this.color.BG + ";";
    },
    colorProgress() {
      return "color:" + this.color.theme + ";";
    },
    //สีพื้นหลังและขอบของ card ที่แสดงรายการ
    displayMobile() {
      if (this.$vuetify.theme.dark){
        return "background: #464646; border: 1px solid #F2F2F2; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1); border-radius: 10px;"
      } else {
        return "background: #FFFFFF; border: 1px solid #F2F2F2; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1); border-radius: 10px;"
      }
    },
    // สีพื้นหลังของ list ที่แสดงรายการไฟล์
    styleDisplayMobile() {
      if (this.$vuetify.theme.dark) {
        return "background: #464646;"
      } else {
        return "background: #FFFFFF;"
      }
    },
    // สีพื้นหลังและเส้นขอบล่างของ list item ของแต่ละอัน
    displayMobileForListItem() {
      if (this.$vuetify.theme.dark) {
        return "background: #464646; border-bottom: 1px solid #F3F5F7;"
      } else {
        return "background: #FFFFFF; border-bottom: 1px solid #F3F5F7;"
      }
    },
    btnAction() {
      return "font-size: 16px; font-weight: lighter;";
    },
    shower: {
      get() {
        if (this.show === true) {
          console.log("show",this.show);
          this.loadprogress = true;
          this.get_check_admin_business();
        }
        return this.show
      }
    }
},
methods: {
  formatdatetime(_datetime) {
      if (
        _datetime === "" ||
        _datetime === "-" ||
        _datetime === undefined ||
        _datetime === null
      ) {
        return "-";
      } else {
        let dateyear =
          _datetime.split("")[0] +
          _datetime.split("")[1] +
          _datetime.split("")[2] +
          _datetime.split("")[3];
        let datemonth = _datetime.split("")[4] + _datetime.split("")[5];
        let dateday = _datetime.split("")[6] + _datetime.split("")[7];
        let hour = _datetime.split("")[8] + _datetime.split("")[9];
        let minute = _datetime.split("")[10] + _datetime.split("")[11];
        let second = _datetime.split("")[12] + _datetime.split("")[13];

        return (
          dateday +
          "/" +
          datemonth +
          "/" +
          dateyear +
          " " +
          hour +
          ":" +
          minute 
          // +
          // ":" +
          // second
        );
      }
    },
    checkdialog() {
       this.$emit("closedialog")
    },
   async get_check_admin_business(){
        var payload = {
          business_id: this.dataAccountActive.business_info.business_id,
        };
        this.axios
        let auth = await gbfGenerate.generateToken();
      await this.axios
          .post(process.env.VUE_APP_SERVICE_ADMIN + "/api/admin/check_admin_business", payload,{headers: { Authorization: auth.code },})
          .then((response) => {
            console.log("response", response);
            if (response.data.status === "OK") {
              this.listadmin = response.data.result;
              console.log("เข้า check_admin_business", this.listadmin);            
              this.total_admin = this.listadmin.length;
              this.loadprogress = false;   
            } else {
               Toast.fire({
                icon: "error",
                title: this.$t("balloon.admin_information_cannot_be_displayed"),
              });
              this.loadprogress = false;  
            }
          })
          .catch((error) => {
            console.log(error);
            Toast.fire({
              icon: "error",
              title: this.$t("toast.cannotconnectonebox"),
            });
            this.loadprogress = false;
          });
        }
},

}
</script>

<style>

</style>